<template>
<div id="UserRoles">
<b-modal id="modal-hist" size="lg" v-model="showHist"  no-close-on-esc no-close-on-backdrop hide-header-close ok-variant cancel-variant hide-footer header-class="PopUpHeader" 
:body-bg-variant=PopUpVar.bodyBgVariant
:body-text-variant=PopUpVar.bodyTextVariant
:footer-bg-variant=PopUpVar.footerBgVariant
:footer-text-variant=PopUpVar.footerTextVariant>
<UserRoleHistory v-if="showHist" :Username="UserData.username"  :UserData="tblHistory"></UserRoleHistory>
<template slot="modal-header"> 
<div>
<small class="PopUpTitle w-100 text-left">{{PopHistTitle}}</small>
</div> 
<div><small class="PopUpTitle w-100 text-right">User Name: {{UserData.username}}</small></div>
</template> 
<div class="w-100">
    <p class="float-left" variant="primary"></p>
    <b-button variant="primary"  size="md"  class="float-left"  @click="showHist=false"> Close </b-button>
</div>
</b-modal> 

<b-modal id="modal-1" v-model="showModal"  no-close-on-esc no-close-on-backdrop hide-header-close
ok-variant cancel-variant hide-footer
header-class="PopUpHeader" 
:body-bg-variant=PopUpVar.bodyBgVariant
:body-text-variant=PopUpVar.bodyTextVariant
:footer-bg-variant=PopUpVar.footerBgVariant
:footer-text-variant=PopUpVar.footerTextVariant> 
<UserRolesAddEdit v-if="showModal==true && Action =='EDIT'" :action="Action" :UserData="UserData"  @roleUpated="closeModal"></UserRolesAddEdit>
 <template slot="modal-header"> 
<div>
<small class="PopUpTitle w-100 text-left">{{PopUpTitle}}</small>
</div> 
<div><small class="PopUpTitle w-100 text-right">User Name: {{UserData.username}}</small></div>
</template> 
</b-modal> 
<Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header>
<i class="fas fa-user-circle"></i><b>Manage User Role:</b>
</template> 
</Subtitle>  
<Card>
  <CardBody>
    <p>Manage User Role is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p>
</CardBody>
</Card> 

   <v-client-table :columns="columns" :data="tableData" :options="options">
     <template slot="status" slot-scope="props">
       <span>{{ props.row.status }}</span>
     </template>
     <span class="pointer" v-on:click="EditUserPopup(props.row)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
     <span class="pointer" v-on:click="HistoryUserPopup(props.row)" slot="history" slot-scope="props" > <i class="fa fa-history" aria-hidden="true"></i></span>
   </v-client-table>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import UserRolesAddEdit from '@/components/DPEBB/Administrator/UserRolesAddEdit.vue';
import UserRoleHistory from '@/components/DPEBB/Administrator/UserRoleHistory.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Subtitle from '@/Common/Default/SubTitle.vue';  
//import UserRoleHistory from './UserRoleHistory.vue';
export default {
   data: function () {
    return {
            Action:'EDIT',
            PopUpTitle :'Edit User Roles',
            PopHistTitle :'User Roles History',
            Roles:[],
            AppServiceID:6,
            roleId:'',
            editUser:'',
            showExit:'',
            returnUrl:'',
            UserData:'', 
            isModalVisible: false,
            showModal: false,
            showHist:false,
            PopUpVar:PopUpVariant,
            columns: ['status','edit','history','username', 'role','servicetype','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
            //columns: ['status','edit','history','username', 'role','servicetype','clinicno','clinicname','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
            tableData: [],
            tblHistory: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search User Data:",
              filterPlaceholder:"Search in table",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['expirydate','effectivedate'],
          toMomentFormat: 'YYYY-MM-DD',
         
          templates: {
            effectivedate(h, row){
              return moment(row.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            expirydate(h, row) {
              return moment(row.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            createddate(h, row) {          
              return moment(row.createddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            modifieddate(h, row) {          
              return moment(row.modifieddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
          },
          headings: {
            edit: 'Edit',
            username: 'User ID',
            role: 'Role',
            status: 'Status',
            servicetype: 'Service Type',
            // clinicno:    'Clinic Number',
            // clinicname:   'Clinic Name',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',            
            createdby: 'Created By',
            createddate: 'Created Date',
            lastmodifiedby: 'Last Modified By',
            modifieddate: 'Last Modified Date'
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['status','username', 'role','servicetype','clinicno','clinicname','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
          filterable: ['status','username', 'role','servicetype','clinicno','clinicname','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
        }
      }
    },
 
    created () {
      this.loadTable();
    },
    methods: {
       EditUserPopup(Rowdata){ 
          this.UserData= Rowdata;
          this.Action = "EDIT"; 
          this.PopUpTitle  = "Edit User Roles";
          this.showModal = true;
        },
        HistoryUserPopup(Rowdata){ 
          this.UserData= Rowdata;  
          this.LoadHistory(Rowdata.username);
          //this.showHist = true;
        },
        closeModal() { 
        this.showModal = false;
        this.loadTable();
        //this.$refs.table.refresh();
      },
      LoadHistory(username){       
        var vm = this;
         axios.get('SaskHealthApi/security/GetUserRoleHistory?_='+Date.now()+'&username='+username, { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
         .then(function (response) {
               vm.tblHistory=response.data;
            })
        .catch(function (er) {
          // if(er.status ==400)
          //   {
          //     ////console.log('here')
          //     vm.showModal = true;
          //     vm.Msg = er.data.message; 
          //   }
             if(er.status == 500)
            {
                vm.showModal = true; 
                if(er.data.message !=null)
                 vm.showMsg(er.data.message);
                 
                else
                vm.Msg = "Network error ! , please contact system administrator." 
            } 
        }).then(function() { 
          //console.log(vm.tblHistory.length)
          if(vm.tblHistory.length > 0)
          {
            vm.showHist = true; 
          }
          else if (vm.tblHistory.length ==0)
          {
            vm.showMsg('No History Record Found');
          } 
        })  
      },
      showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',          
          okTitle: 'Close', 
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            ////console.log('at value ' + value)
            this.boxTwo = value
            if(value)
            {
             
            }
          })
          .catch(err => {
            // An error occurred
          })
      },
      loadTable(){
       
        var vm = this;
         //axios.get('SaskHealthApi/security/GetManagedUsers?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
         axios.get('SaskHealthApi/security/GetUsersRoles?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
         .then(function (response) {
               vm.tableData=response.data;
            })
            .catch(function (er) {
                //console.log(er)
            });
      }
    },
       components: {

        Modal:Modal,
        UserRolesAddEdit:UserRolesAddEdit,
        Card,
        CardBody,
        TileNote,Subtitle,
        UserRoleHistory
    },
    filters: {
      moment: function (date) {        
      return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
      },
    },
      computed:{
          UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        }, 
          AllAppLevel(){
            return this.$store.getters.GetAllApplevel;
          },
    },
}
</script>

<style>

</style>